import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { FileQuestion } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="mx-auto max-w-md text-center"
      >
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-muted">
          <FileQuestion className="h-8 w-8 text-muted-foreground" />
        </div>

        <h1 className="font-heading text-2xl font-semibold text-foreground">
          Essa página não existe
        </h1>
        <p className="mt-2 text-muted-foreground">
          O endereço pode ter mudado ou a página foi removida.
        </p>

        <div className="mt-8">
          <Button variant="hero" asChild>
            <a href="/">Voltar para Home</a>
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
